import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
//import classes from '*.module.css';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontWeight: 'bold',
    color: '#FFFFFF',
    fontSize: 54,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    marginBottom: 16,
    '@media (max-width: 425px)': {
      fontSize: 28,
      marginBottom: 16,
      maxWidth: 296
    }
  },
  sectionSubtitle: {
    fontWeight: 'normal',
    color: '#FFFFFF',
    fontSize: 24,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    '@media (max-width: 425px)': {
      fontSize: 16,
      maxWidth: 296
    }
  },
}));

export default function HeaderSection(props) {
  const { title, subtitle, subtitle2 } = props;

  const classes = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        justifyItems: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 1112,
        width: '100%',
        
      }}
    >
      <div>
        <Typography
          className={classes.sectionTitle}
        >
          {title}
        </Typography>
      </div>

      <div>
        <Typography
          className={classes.sectionSubtitle}
        >
          {subtitle}
        </Typography>
      </div>
      <div>
        <Typography
          style={{ fontWeight: 'normal', color: '#10587f', fontSize: 14 }}
        >
          {subtitle2}
        </Typography>
      </div>
      {props.children}
    </div>
  );
}
